<template>
  <b-form-group>
    <b-input-group
      class="input-group-merge"
    >
      <b-input-group-prepend is-text>
        <feather-icon icon="ClockIcon" />
      </b-input-group-prepend>
      <v-select
        v-model="hour"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="hourArray"
        :reduce="val => val.value"
        class="time-hour"
        :clearable="false"
        input-id="time-hour"
      />
    </b-input-group>
    <b-input-group
      prepend=":"
      class="input-group-merge minute-merge-input"
    >
      <v-select
        v-model="minute"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="minuteArray"
        :reduce="val => val.value"
        class="time-minute"
        :clearable="false"
        input-id="time-minute"
      />
    </b-input-group>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    vSelect,
  },
  props: {
    fieldId: {
      type: Number,
      required: true,
    },
    timeFieldCheck: {
      type: Function,
      required: true,
    },
    fieldVariable: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hour: '',
      minute: '',
      hourArray: [
        { label: '00', value: '00' },
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
      ],
      minuteArray: [
        { label: '00', value: '00' },
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
        { label: '24', value: '24' },
        { label: '25', value: '25' },
        { label: '26', value: '26' },
        { label: '27', value: '27' },
        { label: '28', value: '28' },
        { label: '29', value: '29' },
        { label: '30', value: '30' },
        { label: '31', value: '31' },
        { label: '32', value: '32' },
        { label: '33', value: '33' },
        { label: '34', value: '34' },
        { label: '35', value: '35' },
        { label: '36', value: '36' },
        { label: '37', value: '37' },
        { label: '38', value: '38' },
        { label: '39', value: '39' },
        { label: '40', value: '40' },
        { label: '41', value: '41' },
        { label: '42', value: '42' },
        { label: '43', value: '43' },
        { label: '44', value: '44' },
        { label: '45', value: '45' },
        { label: '46', value: '46' },
        { label: '47', value: '47' },
        { label: '48', value: '48' },
        { label: '49', value: '49' },
        { label: '50', value: '50' },
        { label: '51', value: '51' },
        { label: '52', value: '52' },
        { label: '53', value: '53' },
        { label: '54', value: '54' },
        { label: '55', value: '55' },
        { label: '56', value: '56' },
        { label: '57', value: '57' },
        { label: '58', value: '58' },
        { label: '59', value: '59' },
      ],
    }
  },
  watch: {
    hour: {
      handler() {
        this.timeFieldCheck(this.fieldId, this.fieldVariable)
      },
    },
    minute: {
      handler() {
        this.timeFieldCheck(this.fieldId, this.fieldVariable)
      },
    },
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
.time-hour .vs__dropdown-toggle {
  border-radius: 0px;
  width: 160px;
}

.time-minute .vs__dropdown-toggle {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  width: 160px;
}

.time-hour svg, .time-minute svg {
  display: none;
}

.minute-merge-input .input-group-text {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
</style>
